$(document).ready(function() {
    // Toggle the side navigation
    var $sidebarToggle = $('.sidebarToggle');
    
    if ($sidebarToggle.length) {
        // Uncomment Below to persist sidebar toggle between refreshes
        // if (localStorage.getItem('sb|sidebar-toggle') === 'true') {
        //     $('body').toggleClass('sb-sidenav-toggled');
        // }
        
        $sidebarToggle.on('click', function(event) {
            event.preventDefault();
            $('body').toggleClass('sb-sidenav-toggled');
            localStorage.setItem('sb|sidebar-toggle', $('body').hasClass('sb-sidenav-toggled'));
        });
    }
});
